import { Injectable } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { sortState , EXCLUDE_TAGS} from '../shared/utility/config';
import * as _ from 'underscore';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';
@Injectable()
export class GamingUtility {
  tagsList = [];
  constructor(
    private utils: Utility
  ) {
  }
  private callGoToFeaturedGames = new Subject<boolean>();
  callGoToFeaturedGames$ = this.callGoToFeaturedGames.asObservable();

  private initializeGamesLazyLoad = new Subject<any>();
  initializeGamesLazyLoad$ = this.initializeGamesLazyLoad.asObservable();

  private callGetGamesCategory = new Subject<string>();
  callGetGamesCategory$ = this.callGetGamesCategory.asObservable();

  private callClickSort = new Subject<string>();
  callClickSort$ = this.callClickSort.asObservable();

  private gameDetails = new Subject<any>();
  gameDetails$ = this.gameDetails.asObservable();

  setGameDetails(obj) {
    this.gameDetails.next(obj);
  }

  getGameDetails() {
    return this.gameDetails;
  }

  toInitializeGamesLazyLoad() {
    this.initializeGamesLazyLoad.next("");
  }
  callingGoToFeaturedGames(status:boolean) {
    this.callGoToFeaturedGames.next(status);
  }

  callingGetGamesCategory(value:string) {
    this.callGetGamesCategory.next(value);
  }
  callingClickSort(val) {
    this.callClickSort.next(val);
  }
  openGamingModal(modalId, buttonId) {
    this.utils.openModal(modalId);
    if (this.utils.isUserLoggedIn()) {
      this.utils.enableButton(buttonId, "Play");
    } else {
      this.utils.enableButton(buttonId, "Play for free");
    }
  }
  ascendingSort(targetArr): any{
    let ascendingArr = [];
    ascendingArr = targetArr.sort((n1, n2) => {
      if (n1.name.localeCompare(n2.name) >= 0) return 1;
      if (n1.name.localeCompare(n2.name) < 0) return -1;
      return 0;
    });
    return ascendingArr;
  }

  descendingSort(targetArr): any{
    let descendingArr = [];
    descendingArr = targetArr.sort((n1, n2) => {
      if (n1.name.localeCompare(n2.name) < 0) return 1;
      if (n1.name.localeCompare(n2.name) >= 0) return -1;
      return 0;
    });
    return descendingArr;
  }
  aggregateGameProvider(allGames, vendorLength?): any {
    let gameProviderMap  = new Map(); 
    let gameProviders = new Map();
    let gameVendorCodes = [];
    let sortedGameVendorCodes = [];

    let vendorDetails = new Map();
    let vendors = _.groupBy(allGames, 'vendorCode');
    _.each(vendors, item => {
      vendorDetails.set(item[0].vendorId, item.length);
    });

    if (!allGames) {
      return; // with error
    }
    /** extracting unique set of vendorCodes with vendorDisplayNames */
    _.each(allGames, vendor => {
      gameProviders.set(vendor.vendorId, vendor.vendorDisplayName);
    });
    gameVendorCodes = Array.from(gameProviders.keys());

    /** sorting the gameVendorCodes as per the order of GAME_PROVIDERS_VENDOR_CODE_SORT_ORDER  */
    sortedGameVendorCodes = _.union(
      _.intersection(environment.GAME_PROVIDERS_VENDOR_CODE_SORT_ORDER, gameVendorCodes), gameVendorCodes);

    /** sorting gameProviderMap as of the order of sortedGameVendorCodes */
    _.each(sortedGameVendorCodes, vendorCode => {
      if (vendorLength) {
        gameProviderMap.set(vendorCode, [gameProviders.get(vendorCode), vendorDetails.get(vendorCode)]);
      } else {
        gameProviderMap.set(vendorCode, gameProviders.get(vendorCode));
      }
    });

    return gameProviderMap;
  }

  aggregateGamesTags(allGames): any {

    let tagsOfAllGames = [];
   
    if (!allGames) {
      return; // with error
    }
    /** extracting unique set of vendorCodes with vendorDisplayNames */
    _.each(allGames, game => {
      tagsOfAllGames.push(...game.tagList);
    });
    tagsOfAllGames = Array.from(new Set(tagsOfAllGames));
    this.tagsList = tagsOfAllGames.filter(tag => EXCLUDE_TAGS.indexOf(tag) === -1);
    return this.tagsList;
  }

  copyGameObject(object1, object2) {
    if (!object1)
      object1 = {};
    Object.assign(object1, object2);
  }
  changeState(clickState) { 
    switch (clickState) {
      case sortState.none:
        clickState = sortState.asc;
        break;
      case sortState.asc:
        clickState = sortState.desc;
        break;
      case sortState.desc:
        clickState = sortState.none;
        break;
    }
    return clickState;
  }
}
